// extracted by mini-css-extract-plugin
module.exports = {"emailActions":"salesforce-email-list_emailActions_2n-","deleteBtn":"salesforce-email-list_deleteBtn_2cJ"};